import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Curso } from '../../models/curso.model';
import { CursoService } from '../../services/curso.service';
import { TurmaService } from '../../services/turma.service';
import { TesteService } from '../../services/teste.service';

@Component({
  selector: 'app-monta-turmas',
  templateUrl: './monta-turmas.component.html',
  styleUrls: ['./monta-turmas.component.css'],
})
export class MontaTurmasComponent implements OnInit, OnDestroy {
  // dtOptions: DataTables.Settings = {}; //https://datatables.net/reference/option/
  dtOptionsInstrutores: any = {};
  dtOptionsSalas: any = {};
  dtOptionsTurmasGeradas: any = {};
  dtOptionsProblemasEncontrados: any = {};
  municipios: any = {};
  cursos: Curso[];
  iniciouSimulacao = false;
  gerouErro = false;
  cursoSelecionado = 0;
  totais = {
    inscricoesTotal: 0,
    inscricoesCurso: 0,
    inscricoesSelecionadas: 0,
    alunosInscritos: 0,
  };

  constructor(
    private cursoService: CursoService,
    private testeService: TesteService,
    private turmaService: TurmaService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.cursoService.getCursos().subscribe((res) => {
    //   this.cursos = res;
    // });

    this.testeService.getMunicipios().subscribe((res) => {
      this.municipios = res;
      console.log(res);
    });

    this.dtOptionsInstrutores = {
      dtTrigger: new Subject<any>(),
      paging: false,
      searching: false,
      select: true,
      info: false,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Nome',
          data: 'nomeInst',
        },
      ],
    };

    this.dtOptionsSalas = {
      dtTrigger: new Subject<any>(),
      paging: false,
      searching: false,
      select: true,
      info: false,
      columns: [
        {
          title: 'Número',
          data: 'id',
          render: function (data, type, row, meta) {
            return 'Sala ' + data;
          },
        },
        {
          title: 'Capacidade',
          data: 'qtdCapacidade',
          render: function (data, type, row, meta) {
            return data + ' lugares';
          },
        },
      ],
    };

    this.dtOptionsTurmasGeradas = {
      dtTrigger: new Subject<any>(),
      paging: false,
      searching: false,
      select: true,
      info: false,
      columns: [
        {
          title: 'Id',
          data: 'id',
        },
        {
          title: 'Nome do Curso',
          data: 'txtDescTur',
        },
        {
          title: 'Nome Instrutor',
          data: 'nomeInstrutor',
        },
        {
          title: 'Vagas',
          data: 'qtdVagas',
        },
      ],
    };

    this.dtOptionsProblemasEncontrados = {
      dtTrigger: new Subject<any>(),
      paging: false,
      searching: false,
      info: false,
      columns: [
        {
          title: 'Descrição',
          data: function (data, type, row, meta) {
            return data;
          },
        },
      ],
    };
  }

  ngOnDestroy(): void {
    this.dtOptionsInstrutores.dtTrigger.unsubscribe();
    this.dtOptionsSalas.dtTrigger.unsubscribe();
    this.dtOptionsTurmasGeradas.dtTrigger.unsubscribe();
    this.dtOptionsProblemasEncontrados.dtTrigger.unsubscribe();
  }

  selecionaCurso() {
    this.cursoService.getTotais(this.cursoSelecionado).subscribe((res) => {
      this.totais.inscricoesTotal = res.inscricoesTotal;
      this.totais.inscricoesCurso = res.inscricoesCurso;
    });

    this.cursoService.getSalas(this.cursoSelecionado).subscribe((res) => {
      this.dtOptionsSalas.data = res;
      this.dtRerender(this.dtOptionsSalas);
    });

    this.cursoService.getInstrutores(this.cursoSelecionado).subscribe((res) => {
      this.dtOptionsInstrutores.data = res;
      this.dtRerender(this.dtOptionsInstrutores);
    });
  }

  iniciarSimulacao() {
    this.cursoService.geraSimulacao(this.cursoSelecionado).subscribe(
      (result) => {
        this.totais.inscricoesSelecionadas = result.totalInscricoes;
        this.totais.alunosInscritos = result.totalInscritos;
        this.dtOptionsTurmasGeradas.data = result.turmas;
        this.dtOptionsProblemasEncontrados.data = result.relatorioMontagem;
        // Reload datatables
        this.dtRerender(this.dtOptionsTurmasGeradas);
        this.dtRerender(this.dtOptionsProblemasEncontrados);
        this.iniciouSimulacao = true;
        this.gerouErro = false;
        if (result.turmas.length > 0) {
          this.toastr.info('"Novas turmas foram geradas!');
        }
      },
      (errorResponse) => {
        if (errorResponse.status === 400) {
          this.totais.inscricoesSelecionadas = 0;
          this.totais.alunosInscritos = 0;
          this.dtOptionsTurmasGeradas.data = {};
          const erros: Array<string> = [];
          errorResponse.error.forEach((er: { message: string }) => {
            erros.push('PROBLEMA: ' + er.message);
          });
          this.dtOptionsProblemasEncontrados.data = erros;
          // Reload datatables
          this.dtRerender(this.dtOptionsTurmasGeradas);
          this.dtRerender(this.dtOptionsProblemasEncontrados);
          this.iniciouSimulacao = true;
          this.gerouErro = true;
        } else {
          throw errorResponse;
        }
      }
    );
  }

  efetivarInscricoes() {
    const ids: Array<number> = [];
    this.dtOptionsTurmasGeradas.data.forEach((e) => {
      ids.push(e.id);
    });

    this.turmaService.efetivaInscricoes(ids).subscribe(() => {
      this.toastr.info('Turmas efetivadas com sucesso!');
    });
  }

  cancelarInscricoes() {
    // força recarregar a view
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/inscricoes/monta-turmas']));
  }

  dtRerender(dtOptions: any) {
    dtOptions.destroy = true;
    dtOptions.dtTrigger.next();
  }
}
